import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import config from '../functions/config';

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Handle login
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
        const response = await fetch(`${config.BASE_URL}/api/login/`, {

        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        Cookies.set('sessionid', data.sessionid);


        console.log("Session ID in login:", data.sessionid);

        if (data.redirectTo) {
          navigate(data.redirectTo);
        }
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Invalid login credentials");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  // Auto-dismiss error notification after 3 seconds
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [error]);


const [isOpen, setIsOpen] = useState(false);

const toggleNavbar = () => {
  setIsOpen(!isOpen);
};
return (
  <div style={styles.pageContainer}>
    {/* Navbar */}
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 fixed-top">
    <div className="container-fluid">
      <a className="navbar-brand" href="#">📚 Library</a>
      <button 
        className="navbar-toggler" 
        type="button" 
        onClick={toggleNavbar}
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
        <ul className="navbar-nav ms-auto">
          <li className="nav-item">
            <Link className="nav-link" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">About</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/login">Login</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/signup">Register</Link>
          </li>
        </ul>
      </div>
    </div>
  </nav>

      {/* Login Form */}
      <div style={styles.formContainer} className='container mt-4 mb-2 ml-5 mr-5'>
        <div style={styles.card}>
          <h2 style={styles.heading} className="text-center">Login</h2>
          {error && (
            <div style={styles.errorNotification} className="error-notification mt-5">
              {error}
            </div>
          )}
          <form onSubmit={handleLogin}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Username</label>
              <input
                type="text"
                style={styles.input}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Password</label>
              <input
                type="password"
                style={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="mb-3" style={styles.submitButton}>Login</button>


   </form>
   <a href="/signup" className="text-primary pt-5 mt-5"><button type="submit" className="mb-3" style={styles.submitButton}>Register</button>    </a>   

        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <p className="mb-0">&copy; 2024 Library Management System | Designed with ❤️ by Your Team</p>
      </footer>
    </div>
  );
};

// Inline Styles
const styles = {
  pageContainer: {
    fontFamily: "'Roboto', sans-serif",
    minHeight: "100vh",
    backgroundImage: "url('https://www.acg.edu/wp-content/uploads/2022/06/IGA-student-journal-featured-image.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundBlendMode: "overlay",
    opacity: "0.9",
    display: "flex",
    flexDirection: "column",
    paddingTop: "80px", // Add padding to prevent overlap
  },

  formContainer: {
    maxWidth: "700px",
    borderRadius: "20px",
    flex: 2,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    padding: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    margin: "auto",
  },
  card: {
    backgroundColor: "transparent",
    padding: "40px",
    borderRadius: "10px",
  },

  heading: {
    color: "#fff",
    marginBottom: "20px",
  },

  formGroup: {
    marginBottom: "15px",
  },

  label: {
    display: "block",
    marginBottom: "5px",
    color: "#fff",
    fontWeight: "bold",
  },

  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid black",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "black",
  },

  submitButton: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "orange",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  },

  errorNotification: {
    position: "fixed",
    top: "20px",
    right: "20px",
    backgroundColor: "#ff4d4d",
    color: "#fff",
    padding: "15px 20px",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    zIndex: 9999,
    animation: "fade-in-out 3s forwards",
  },

  footer: {
    backgroundColor: "#343a40",
    color: "white",
    padding: "15px 0",
    textAlign: "center",
  },
};

export default Login;
